module.exports = __webpack_public_path__ + "img/G-3-952x410.472be656.png";